import { render, staticRenderFns } from "./FileInput.vue?vue&type=template&id=3624d1d4&scoped=true&"
import script from "./FileInput.vue?vue&type=script&lang=js&"
export * from "./FileInput.vue?vue&type=script&lang=js&"
import style0 from "./FileInput.vue?vue&type=style&index=0&id=3624d1d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3624d1d4",
  null
  
)

export default component.exports